import { Component, OnInit, Input, Injectable } from "@angular/core";
import { NgbInputDatepicker,NgbDatepickerI18n,NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from "../service/common.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
const I18N_VALUES = {
  ja: {
    weekdays: ["月", "火", "水", "木", "金", "土", "日"],
    months: [
      "1月",
      "2月",
      "3月",
      "4月",
      "5月",
      "6月",
      "7月",
      "8月",
      "9月",
      "10月",
      "11月",
      "12月",
    ],
  },
};
@Injectable()
export class I18n {
  language = "ja";
}
@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
  constructor(private _i18n: I18n) {
    super();
  }
  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }
}
@Component({
  selector: "search-yoyaku-day-model-app",
  templateUrl: "./search-yoyaku-day-model.component.html",
  styleUrls: ["search-yoyaku-day-model.component.css"],
})
export class SearchYoyakuDayModelComponent {
  @Input() searchYoyakuDate: any;

  constructor(
    public commonService: CommonService,
    public activeModal: NgbActiveModal
  ) {}

  displayMonths = 1;
  ret: any = {
    status: "",
    selectedData: [],
  };
  //起動時処理
  ngOnInit(): void {

  }
  OK(): void {
    this.ret.status = "OK";
    this.ret.selectedData = this.commonService.formatYYYYMMDD(this.searchYoyakuDate);
    this.activeModal.close(this.ret);
  }
  //キャンセル時
  Cancel() {
    this.ret.status = "Cancel";
    this.activeModal.close(this.ret);
  }
  /**
   * 切り替えるDatePicker以外を閉じながら、
   * toggleで表示非表示を切り替える
   *
   * @param selectDp 切り替えるDatePicker
   */
  toggleDate(selectDp: NgbInputDatepicker): void {
    selectDp.toggle();
  }
}



// WEBPACK FOOTER //
// ./src/app/a0108-person/search-yoyaku-day-model.component.ts